"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Zeigt Layerinformationen in einem Dialogfenster an.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.layer.GCAbstractLayer} options.layer Anzuzeigender Layer
 */
gc.gis.action.layer.ShowLayerInfo = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.doExecute;
	/**
	 * @inheritdoc
	 */
	this.args = [this, options.layer];
};
gc.gis.action.layer.ShowLayerInfo.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * Zeigt die Layerinformationen in einem Dialogfenster an.
 * Feuert bei internen Layern einen Ajax-Request ab, der die Layerinfos
 * abholt.
 *
 * @public
 * @param {gc.gis.action.layer.ShowLayerInfo} self Self-Reference
 * @param {gc.gis.layer.GCAbstractLayer} layer angeforderter Layer bzw. Layerdefinition
 */
gc.gis.action.layer.ShowLayerInfo.prototype.doExecute = function( self, layer )
{
	var is_internal = (typeof layer.isInternal === 'function' && layer.isInternal()) ||
		(typeof layer.isInternal === 'boolean' && layer.isInternal === true );

	if( is_internal )
	{
		var id = typeof layer.getId === 'function' ? layer.getId() : layer.id;
		gc.gis.iface.request.ajax({
			label: 'Ermittle Ebeneninformen ... ',
			context: this,
			url: gc.gis.GCUrl.buildUrl(gc.gis.iface.requests.layerInfoUrl, {'id': id}),
			success: function( data ) {
                self.showInfo( layer, JSON.parse(data).results )
			}
		});
	}
	else
	{
		var con_type = 'Unbekannt';
		if( layer.getType() === gc.gis.layer.GCLayerType.EXTERNAL_WMS )
		{
			con_type = 'Externer WMS';
		}
		else if( layer.getType() === gc.gis.layer.GCLayerType.EXTERNAL_WFS )
		{
			con_type = 'Externer WFS';
		}

		var info = {
			general: {
				layerType: {
					label: 'Typ',
					value:  (layer instanceof gc.gis.layer.GCRasterLayer ? 'Raster' : 'Vektor')
				},
				name: {
					label: 'Name',
					value: layer.getName()
				},
				label: {
					label: 'Bezeichnung',
					value: layer.getLabel()
				},
				connectionType: {
					label: 'Datenquelle',
					value:  con_type
				} ,
				minScale: {
					label: 'Minimaler Darstellungsmaßstab',
					value: layer.getMinScale()
				},
				maxScale: {
					label: 'Maximaler Darstellungsmaßstab',
					value: layer.getMaxScale()
				}
			}
		};
		layer.getExtent( function( result ) {
			info.general.extent = {
				label: 'Ausdehnung',
				value: result.extent
			};
			self.showInfo( layer, info );
		});
	}
};

/**
 * Zeigt den Infodialog an.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer Layerinstanz
 * @param {Object<string,*>} info Layereigenschaften
 */
gc.gis.action.layer.ShowLayerInfo.prototype.showInfo = function( layer, info )
{
	var label = (typeof layer.getLabel === 'function' ? layer.getLabel() : layer.label) || '__FEHLER__';

	var element_content = jQuery('<div>');
	if( info.general )
	{
		element_content.append( this.__renderInfo('Allgemein', info.general ) );
	}
	if( info.metadata )
	{
		element_content.append( this.__renderInfo('Metadaten', info.metadata ) );
	}

	gc.gis.iface.ui.showDialog({
		type: gc.gis.widget.GCDialogType.MESSAGE,
		title: 'Ebeneninformationen zu "<strong>'+ label +'</strong>"',
		content: element_content,
		onCancel: function( dlg ) {
			dlg.dispose();
		}
	});
};

/**
 * Rendert die Layerinfos in ein jQuery-Element.
 *
 * @param {string} label Layerbezeichnung
 * @param {Object<string,*>} info Layereigenschaften
 * @return {jQuery} jQuery-Element
 */
gc.gis.action.layer.ShowLayerInfo.prototype.__renderInfo = function( label, info )
{
	// Container
	var element = jQuery('<div>', {
		'class': 'gc-layerinfo-section'
	});

	// Label
	var element_label = jQuery('<h4>', {
		'class': 'gc-layerinfo-section-label',
		text: label
	});
	element.append( element_label );

	// Liste
	var element_ul = jQuery('<ul>', {
		'class': 'gc-list-key-value'
	});
	var keys = Object.keys( info );
	for( var i=0; i<keys.length; i++ )
	{
		if(keys[i] === 'id' || keys[i] === '')
		{
			continue;
		}

		var value = info[keys[i]].value;
		if(!value)
		{
			continue;
		}

		if(keys[i] === 'extent')
		{
			if (value.length > 0 && value[0] && value[1] && value[2] && value[3])
			{
				value = this.__renderExtent(value);
			}
			else
			{
				continue;
			}
		}

		var li = jQuery('<li>', {
			'class': 'gc-entry'
		});
		var span_key = jQuery('<span>', {
			'class': 'gc-key',
			text: (info[keys[i]].label || keys[i]) +':'
		});
		var span_value = jQuery('<span>', {
			'class': 'gc-value',
			html: value
		});
		li.append( span_key ).append(' ').append( span_value );
		element_ul.append( li );
	}
	element.append( element_ul );

	return element;
};

/**
 * Rendert einen Extent in ein jQuery-Element.
 *
 * @param extent {gc.gis.map.GCMapExtent} Extent
 * @return {jQuery} jQuery-Element
 */
gc.gis.action.layer.ShowLayerInfo.prototype.__renderExtent = function( extent )
{
	var element = jQuery('<span>', {
		'class': 'gc-layer-extent'
	});

	element.append( jQuery('<span>', {
		'class': 'gc-layer-extent-value gc-layer-extent-minx',
		text: extent[0]
	}) );
	element.append( jQuery('<span>', {
		'class': 'gc-layer-extent-value gc-layer-extent-miny',
		text: extent[1]
	}) );
	element.append( jQuery('<span>', {
		'class': 'gc-layer-extent-value gc-layer-extent-maxx',
		text: extent[2]
	}) );
	element.append( jQuery('<span>', {
		'class': 'gc-layer-extent-value gc-layer-extent-maxy',
		text: extent[3]
	}) );

	return element;
};
